module.exports = __webpack_public_path__ + "img/money.8d7b599f.png";